module.exports = __webpack_public_path__ + "static/appendix_1_silver_the_science_behind_the_scene_method_of_action-4f6325201dca079190dcb332babfec2e.pdf";